// Единая шкала грейдов управленческой диагностики.
// Используется в DiagnosticDetail.vue, FullReportPreviewModal.vue и ShortReportPreviewModal.vue —
// раньше была продублирована в каждом файле по отдельности.
export const GRADES = [
  {
    label: 'Базовый уровень',
    color: '#e53935',
    bg: '#ffebee',
    range: '0 – 0.9',
  },
  {
    label: 'Уровень развития',
    color: '#fb8c00',
    bg: '#fff3e0',
    range: '1 – 1.9',
  },
  {
    label: 'Уровень опыта',
    color: '#f9a825',
    bg: '#fffde7',
    range: '2 – 2.5',
  },
  {
    label: 'Уровень мастерства',
    color: '#43a047',
    bg: '#e8f5e9',
    range: '2.6 – 3',
  },
];

export function getGrade(score) {
  if (score === null || score === undefined) return null;
  if (score < 1) return GRADES[0];
  if (score < 2) return GRADES[1];
  if (score <= 2.5) return GRADES[2];
  return GRADES[3];
}
